import styled from 'styled-components';

export const ConditionalDisplay = styled.div<{$isDisplayed: boolean}>`
  display: ${({$isDisplayed}) => ($isDisplayed ? 'block' : 'none')};
`;
